import { useEffect, useState } from "react"
import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Button } from "@mui/material"

import BackIcon from "../../../components/BackIcon"
import CustomFieldset from "../../../components/CustomFieldset"
import CustomHelperDetail from "../../../components/CustomHelperDetail"
import CustomTooltip from "../../../components/ToolTip"
import CustomDatePicker from "../../../components/CustomDatePicker"
import dayjs from "dayjs"
import CustomTextField from "../../../components/CustomTextField"
import CustomSelect from "../../../components/CustomSelect"
import CustomAutocomplete from "../../../components/CustomAutocomplete"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import CustomBackdrop from "../../../components/CustomBackdrop"
import EjecutarIcon from "../../../assets/iconos/EjecutarAccion.ico"
import CustomMultiSelectCheckmark from "../../../components/CustomMultiSelectCheckmark"
import DatagridAllPickings from "../components/DatagridAllPickings"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const ContainerFiltros = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
        "IPicking IPicking IPicking IUsuario IUsuario IUsuario ITipo ITipo ITipo IFechaInicial IFechaInicial IFechaInicial"
        "IDetalle IDetalle IDetalle IDetalle IDetalle IEstado IEstado IEstado IEstado IFechaFinal IFechaFinal IFechaFinal"
        "ICliente ICliente ICliente ICliente ICliente ICliente IArticulo IArticulo IArticulo IArticulo IArticulo IArticulo"
      `,
  gap: "8px",
  alignItems: "center",
}))

const IPicking = styled(Box)({
  gridArea: "IPicking",
})

const IUsuario = styled(Box)({
  gridArea: "IUsuario",
})
const ITipo = styled(Box)({
  gridArea: "ITipo",
})

const IFechaInicial = styled(Box)({
  gridArea: "IFechaInicial",
})

const IDetalle = styled(Box)({
  gridArea: "IDetalle",
})

const IEstado = styled(Box)({
  gridArea: "IEstado",
})

const IFechaFinal = styled(Box)({
  gridArea: "IFechaFinal",
})

const ICliente = styled(Box)({
  gridArea: "ICliente",
})
const IArticulo = styled(Box)({
  gridArea: "IArticulo",
})

const CierrePickingCrear = () => {
  const queryClient = useQueryClient()

  const [filtros, setFiltros] = useState({
    picking: "",
    usuario: null,
    tipo: {},
    detalle: "",
    estados: [],
    cliente: {},
    articulo: {},
    fechaInicial: dayjs(new Date(new Date().getFullYear(), new Date().getMonth(), 1)),
    fechaFinal: dayjs(new Date()),
  })

  const handleSetFiltros = (k, v) => setFiltros((prev) => ({ ...prev, [k]: v }))

  const {
    data: fetchedUsuarios = [],
    isError: isLoadingUsuariosoError,
    isFetching: isFetchinUsuarios,
    isLoading: isLoadingUsuarios,
  } = useGetUsuarios()

  function useGetUsuarios() {
    return useQuery({
      queryKey: ["USUARIOSCierrePicking"],
      queryFn: async () => {
        let response = await fetchwrapper(`/pickingSugerido/getUsuarios`)
        response = await response.json()

        return response.data
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    })
  }

  const {
    data: fetchedFilteredPickings = [],
    isError: isLoadingFilteredPickingsError,
    isFetching: isFetchingFilteredPickings,
    isLoading: isLoadingFilteredPickings,
    refetch: refetchFilteredPickings,
  } = useGetFilteredPickings()

  function useGetFilteredPickings() {
    return useQuery({
      queryKey: ["fetchedFilteredPickingsCierreCrear"],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({
            ...filtros,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        let response = await fetchwrapper(`/CierrePicking/getAllPickings`, options)
        response = await response.json()

        return response.data
      },
      refetchOnWindowFocus: false,
      staleTime: 0,
      enabled: false,
      cacheTime: 0,
    })
  }
  useEffect(() => {
    return () => {
      // Limpia la caché cuando el componente se desmonta
      queryClient.removeQueries(["fetchedFilteredPickingsCierreCrear"])
    }
  }, [queryClient])

  const handleSearching = () => {
    refetchFilteredPickings()
  }

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "5px" }}>
            <CustomTooltip title={"Ejecutar"}>
              <Button onClick={handleSearching}>
                <img src={EjecutarIcon} alt="Ejecutar" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Crear Cierre de Picking</b>
        </div>

        <CustomBackdrop isLoading={isLoadingUsuarios || isFetchinUsuarios} />

        <Box className={StyledRoot}>
          <CustomFieldset title={"Parámetros de Búsqueda"}>
            <ContainerFiltros>
              <IPicking>
                <CustomTextField
                  label="Picking"
                  value={filtros.picking}
                  setValue={(v) => handleSetFiltros("picking", v)}
                />
              </IPicking>

              <IUsuario>
                <CustomAutocomplete
                  label="Usuario"
                  selectedOption={filtros.usuario}
                  setSelectedOption={(v) => handleSetFiltros("usuario", v)}
                  options={fetchedUsuarios}
                />
              </IUsuario>

              <ITipo>
                <CustomSelect
                  label="Tipo"
                  selectedOption={filtros.tipo}
                  setSelectedOption={(v) => handleSetFiltros("tipo", v)}
                  options={[
                    { value: "INDIVIDUAL", label: "INDIVIDUAL" },
                    { value: "TANDA", label: "TANDA" },
                    { value: "MULTIBATCH", label: "MULTI-BATCH" },
                    { value: "ZONA", label: "ZONA" },
                    { value: "OLA", label: "OLA" },
                  ]}
                />
              </ITipo>

              <IDetalle>
                <CustomTextField
                  label="Detalle"
                  value={filtros.detalle}
                  setValue={(v) => handleSetFiltros("detalle", v)}
                  fullwidth
                />
              </IDetalle>

              <IEstado>
                <CustomMultiSelectCheckmark
                  label="Estado"
                  selectedOptions={filtros.estados}
                  setSelectedOptions={(v) => handleSetFiltros("estados", v)}
                  options={[
                    { value: "PENDIENTE", label: "PENDIENTE" },
                    { value: "RECIBIDA PARCIAL", label: "RECIBIDA PARCIAL" },
                  ]}
                />
              </IEstado>

              <ICliente>
                <CustomHelperDetail
                  label="Cliente"
                  valueSearched={filtros.cliente?.clicodigo}
                  endpoint="/pickingSugerido/getClientesHelper"
                  valueInputMain="clicodigo"
                  valueInputSecondary="clinombre"
                  idSearchField="clicodigo"
                  errorMsgIdSearch="Error fetching data:"
                  errorMsgFilterSearch="Error en cargar datos"
                  queryKeyModal="clienteBodegaPickingSugerido"
                  perPage={10}
                  placeholder=""
                  columnsTable={[
                    {
                      accessorKey: "ciacodigo",
                      header: "Ciacodigo",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "clicodigo",
                      header: "Código de Cliente",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "clinombre",
                      header: "Nombre del Cliente",
                      size: 250,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "cliruc",
                      header: "Número de identificación",
                      size: 150,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "clitelef1",
                      header: "Teléfono",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "clidirec",
                      header: "Dirección",
                      size: 400,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <p>{value}</p>
                      },
                    },
                    {
                      accessorKey: "clireferencia1",
                      header: "Referencia Rápida",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <p>{value}</p>
                      },
                    },
                    {
                      accessorKey: "zoncodigo",
                      header: "Zona",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "clistatus",
                      header: "Estado",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        if (value === "A") return "Activo"
                        if (value === "I") return "Inactivo"
                        return <span>{value}</span>
                      },
                    },
                  ]}
                  onHandleSelectedData={(v) => handleSetFiltros("clienteBodega", v)}
                  sxInputMain={{
                    minWidth: "170px",
                    maxWidth: "170px",
                    marginRight: "10px",
                  }}
                  sxInputSecondary={{
                    width: "100%",
                  }}
                />
              </ICliente>

              <IArticulo>
                <CustomHelperDetail
                  label="Artículo"
                  valueSearched={filtros.articulo?.artcodigo}
                  endpoint="/CierrePicking/getArticulosHelper"
                  valueInputMain="artcodigo"
                  valueInputSecondary="artdescri"
                  idSearchField="artcodigo"
                  errorMsgIdSearch="Error fetching data:"
                  errorMsgFilterSearch="Error en cargar datos"
                  queryKeyModal="articuloCierrepicking"
                  perPage={10}
                  placeholder=""
                  columnsTable={[
                    {
                      accessorKey: "artcodigo",
                      header: "Código",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artdescri",
                      header: "Descripción",
                      size: 150,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artcantactual",
                      header: "Cantidad Actual",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artprecventa1",
                      header: "Precio Venta 1",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "mardescri",
                      header: "Marca",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artcodigo2",
                      header: "Código 2",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "lindescri",
                      header: "Línea",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "predescri",
                      header: "Precio Descripción",
                      size: 150,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "meddescri",
                      header: "Medida",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artprecventa2",
                      header: "Precio Venta 2",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artprecventa3",
                      header: "Precio Venta 3",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artprecventa4",
                      header: "Precio Venta 4",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artprecventa5",
                      header: "Precio Venta 5",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artprecventa6",
                      header: "Precio Venta 6",
                      size: 120,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                    {
                      accessorKey: "artstatus",
                      header: "Estado",
                      size: 100,
                      Cell: ({ cell }) => {
                        const value = cell.getValue()
                        return <span>{value}</span>
                      },
                    },
                  ]}
                  onHandleSelectedData={(v) => handleSetFiltros("articulo", v)}
                  sxInputMain={{
                    minWidth: "170px",
                    maxWidth: "170px",
                    marginRight: "10px",
                  }}
                  sxInputSecondary={{
                    width: "100%",
                  }}
                />
              </IArticulo>

              <IFechaInicial>
                <CustomDatePicker
                  label="Fecha Inicial"
                  value={filtros.fechaInicial}
                  setValue={(v) => handleSetFiltros("fechaInicial", v)}
                  isOptional={true}
                />
              </IFechaInicial>

              <IFechaFinal>
                <CustomDatePicker
                  label="Fecha Final"
                  value={filtros.fechaFinal}
                  setValue={(v) => handleSetFiltros("fechaFinal", v)}
                  isOptional={true}
                />
              </IFechaFinal>
            </ContainerFiltros>
            <div style={{ paddingTop: "10px", paddingBottom: "10px", textAlign: "end" }}>
              <Button variant="contained" color="primary" onClick={handleSearching}>
                Buscar
              </Button>
            </div>
          </CustomFieldset>
          <br />
          <br />
          <DatagridAllPickings
            fetchedInfo={fetchedFilteredPickings}
            isLoadingInfoError={isLoadingFilteredPickingsError}
            isLoadingInfo={isLoadingFilteredPickings}
            isFetchingInfo={isFetchingFilteredPickings}
            columnsTable={[
              {
                accessorKey: "ciacodigo",
                header: "Cía",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "sgapicking",
                header: "Picking",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "sgafecpick",
                header: "Fecha Emisión",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span>
                },
              },
              {
                accessorKey: "sgahorpick",
                header: "Hora Emisión",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "sgafecpicking",
                header: "Fecha Picking",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span>
                },
              },
              {
                accessorKey: "sgahorpicking",
                header: "Hora Picking",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "sgapickdescri",
                header: "Comentario Picking",
                size: 200,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "sgausupicking",
                header: "Usuario Picking",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "sgapicktipo",
                header: "Tipo Picking",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
              {
                accessorKey: "sgapickstatus",
                header: "Estado",
                size: 100,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{value}</span>
                },
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default CierrePickingCrear
